const defaultFormId = "flow-form";

export const BackButton = () => ({
  /**
   *
   * @param {Event} event
   */
  async onBackClick(event) {
    event.preventDefault();

    const form = document.getElementById(defaultFormId);

    const callback = async () => {
      const inputs = document.querySelectorAll(`#${defaultFormId} input`);

      inputs.forEach((input) => {
        input.removeAttribute("required");
      });

      form.action = this.$el.formAction;
      form.submit();
    }

    if (window.RECAPTCHA_ENABLED && 
        form.querySelector('input[name="g-recaptcha-response"]') && 
        typeof window.requestReCaptchaToken === "function") {
      await window.requestReCaptchaToken(form, callback);
    } else {
      await callback();
    }    
  },
});
